import React, { useState } from 'react';
import ViewTable from 'app/shared/view-table/view-table';
import ViewTableHeaderColumn from 'app/shared/view-table/view-table-header-column';
import { useParams } from 'react-router-dom';
import { Button } from 'edozvola-frontend-lib/dist/ui/components';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { deleteRpjLocationQuery, fetchRpjLocationsQuery } from 'app/edozvola/cases/case-location/service/case-location.queries';
import { RpjLocationView } from 'app/edozvola/cases/case-location/model/case-location.model';
import { TABLE_QUERY_KEYS } from 'app/config/constants';
import { getInvalidRowsForTable } from 'app/shared/util/validation-errors.util';
import { getCaseContext } from 'app/shared/util/context-util';
import { TooltipWrapper } from 'edozvola-frontend-lib/dist/ui/components/tooltipwrapper';

const CaseLocationRpjLocationTable = ({ setRpjLocationId, setReadOnly }) => {
  const { id } = useParams<{ id: string }>();
  const [idRpjLocationToDelete, setIdRpjLocationToDelete] = useState();
  const [deleteModalShown, setDeleteModalShown] = useState(false);
  const { sidebarItemPair } = getCaseContext();

  const invalidRowIds = getInvalidRowsForTable(TABLE_QUERY_KEYS.RPJ_LOCATIONS_TABLE);

  const { mutate: deleteRpjLocationMutation, isPending: rpjLocationDeletionPending } = deleteRpjLocationQuery();

  const openDeleteDialog = idToDelete => {
    setIdRpjLocationToDelete(idToDelete);
    setDeleteModalShown(true);
  };

  const removeRpjLocation = () => {
    setDeleteModalShown(false);
    deleteRpjLocationMutation(idRpjLocationToDelete);
  };
  const openRpjLocationForm = (idRpjLocation: number, readOnly: boolean) => {
    setRpjLocationId(idRpjLocation);
    setReadOnly(readOnly);
  };

  const renderTableRow = (value: RpjLocationView, rpjLocationIndex: number, totalItems: number) => {
    return (
      <tr key={rpjLocationIndex} className={invalidRowIds.includes(value.idRpjLocation) ? 'invalid-table-row' : ''}>
        <td>{value.countyCityMunicipality}</td>
        <td>{value.communityStreetHouseNumber}</td>
        <td>
          <div className={'actions-container'}>
            {sidebarItemPair?.canEdit && (
              <TooltipWrapper message={'Uredi'}>
                <FontAwesomeIcon
                  icon={'pen-to-square'}
                  className={'icon-table'}
                  onClick={() => openRpjLocationForm(value.idRpjLocation, false)}
                />
              </TooltipWrapper>
            )}
            {sidebarItemPair?.canDelete && (
              <TooltipWrapper message={'Obriši'}>
                <FontAwesomeIcon icon={'trash-alt'} className={'icon-table'} onClick={() => openDeleteDialog(value.idRpjLocation)} />
              </TooltipWrapper>
            )}
          </div>
        </td>
      </tr>
    );
  };

  return (
    <>
      <ViewTable
        renderTableRow={renderTableRow}
        noDataMessage={'Nema dodanih adresnih podataka'}
        initialPaginationColumn={'idRpjLocation'}
        fetchDataQuery={fetchRpjLocationsQuery}
        fetchDataProps={[id]}
      >
        <ViewTableHeaderColumn renderSort sortKey={'countyCityMunicipality'} columnLabels={['Županija, Grad/Općina']} width={'20%'} />
        <ViewTableHeaderColumn renderSort sortKey={'communityStreetHouseNumber'} columnLabels={['Naselje, Ulica i kućni broj']} width={'20%'} />
        <ViewTableHeaderColumn renderSort={false} columnLabels={['Akcije']} width={'3%'} />
      </ViewTable>
      <Modal scrollable isOpen={deleteModalShown} size={'lg'} toggle={() => setDeleteModalShown(false)} centered>
        <ModalHeader>
          <span>Brisanje adrese</span>
        </ModalHeader>
        <ModalBody>
          <div>Jeste li sigurni da želite obrisati podatke?</div>
        </ModalBody>
        <ModalFooter>
          <Button size={'lg'} label="Odustani" outline onClick={() => setDeleteModalShown(false)} />
          <Button size={'lg'} label="Obriši" color={'danger'} onClick={removeRpjLocation} />
        </ModalFooter>
      </Modal>
    </>
  );
};

export default CaseLocationRpjLocationTable;
